@if (userService.userIsAdmin) {
  <div class="client-headline d-flex">
    <h5>{{ 'app.client' | translate }}</h5>
  </div>
}

<mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
  <mat-tree-node
    matTreeNodeToggle
    [matTreeNodeToogle]="true"
    [matTreeNodeToggleRecursive]="true"
    *matTreeNodeDef="let node"
    matTreeNodePadding
    [matTreeNodePaddingIndent]="16"
    [ngClass]="{
      'h-0':
        !userService.userIsAdmin &&
        node.type === _SidenavElement.ADD_REPORT_BUTTON
    }"
    >
    <div class="icon-align" [ngClass]="{ active: node.id === activeRouteID }">
      <button mat-icon-button disabled></button>

      <!-- Report -->
      @if (node.type === _SidenavElement.REPORT) {
        <mat-icon [routerLink]="['/report', node.id]">description</mat-icon>
        <a class="report-name-tree" [routerLink]="['/report', node.id]">{{
          node.name
        }}</a>
        @if (userService.userIsAdmin && node.id === activeRouteID) {
          <mat-icon
            class="edit-icon"
          (click)="
            !userService.userIsAdmin || addReport(node.id, $event, 'edit')
          "
            >edit</mat-icon
            >
          }
        }

        <!-- Add Report -->
        @if (
          node.type === _SidenavElement.ADD_REPORT_BUTTON &&
          userService.userIsAdmin
          ) {
          <div class="add-report-button" (click)="addReport(node.id, $event)">
            <mat-icon>note_add</mat-icon>
            <div class="tree-node-label">{{ node.name }}</div>
          </div>
        }

        <!-- Project -->
        @if (node.level === 1) {
          <mat-icon>folder</mat-icon>
          <div class="tree-node-label">
            {{ node.name }}
          </div>
          @if (userService.userIsAdmin) {
            <mat-icon
              class="edit-icon"
              (click)="!userService.userIsAdmin || editProject(node.id, $event)"
              >edit</mat-icon
              >
            }
          }

          <!-- Client -->
          @if (node.level === 0) {
            <div class="tree-node-label">
              {{ node.name }}
            </div>
            @if (userService.userIsAdmin) {
              <mat-icon
                class="edit-icon"
                (click)="!userService.userIsAdmin || editClient(node.id, $event)"
                >edit</mat-icon
                >
              }
            }
          </div>
        </mat-tree-node>
        <mat-tree-node
          matTreeNodeToggle
          *matTreeNodeDef="let node; when: hasChild"
          matTreeNodePadding
          [matTreeNodePaddingIndent]="16"
          [matTreeNodeToogle]="true"
          [matTreeNodeToggleRecursive]="true"
    [ngClass]="{
      'h-0':
        !userService.userIsAdmin &&
        node.type === _SidenavElement.ADD_REPORT_BUTTON
    }"
          >
          <button mat-icon-button [attr.aria-label]="'Toggle ' + node.name">
            <mat-icon class="mat-icon-rtl-mirror">
              {{ treeControl.isExpanded(node) ? "expand_more" : "chevron_right" }}
            </mat-icon>
          </button>
          <!-- @ToDo duplicated code -->
          <!-- Report -->
          @if (node.type === _SidenavElement.REPORT) {
            <mat-icon [routerLink]="['/report', node.id]">description</mat-icon>
            <a class="report-name-tree" [routerLink]="['/report', node.id]">{{
              node.name
            }}</a>
            @if (userService.userIsAdmin) {
              <mat-icon
                class="edit-icon"
                (click)="!userService.userIsAdmin || addReport(node.id, $event)"
                >edit</mat-icon
                >
              }
            }

            <!-- Add Report -->
            @if (
              node.type === _SidenavElement.ADD_REPORT_BUTTON &&
              userService.userIsAdmin
              ) {
              <div class="add-report-button" (click)="addReport(node.id, $event)">
                <mat-icon>note_add</mat-icon>
                <div class="tree-node-label">{{ node.name }}</div>
              </div>
            }

            <!-- Project -->
            @if (node.level === 1) {
              <mat-icon>folder</mat-icon>
              <div class="tree-node-label">
                {{ node.name }}
              </div>
              @if (userService.userIsAdmin) {
                <mat-icon
                  class="edit-icon"
                  (click)="!userService.userIsAdmin || editProject(node.id, $event)"
                  >edit</mat-icon
                  >
                }
              }

              <!-- Client -->
              @if (node.level === 0) {
                <div class="tree-node-label">
                  {{ node.name }}
                </div>
                @if (userService.userIsAdmin) {
                  <mat-icon
                    class="edit-icon"
                    (click)="!userService.userIsAdmin || editClient(node.id, $event)"
                    >edit</mat-icon
                    >
                  }
                }
              </mat-tree-node>
            </mat-tree>
